export default __webpack_public_path__ + "static/media/3136.cea3f318.jpg";